import { applyAsStep1 } from "./config";
import { IApplicationFrontEndModelStep1, TAppValidator } from "../../../types";
import { mutateErrors } from "../../../../../utils";
import { WIZARD_ERROR_MESSAGE } from "../../../../wizard/constants";
import { EducationType } from "../../../../school/constants/types";

const STUDENT_ERROR_MESSAGE = "Student is required";
const INTAKE_ERROR_MESSAGE = "Intake is required";
const BRANCH_ERROR_MESSAGE = "Branch is required";
const RESTRICTED_COUNTRY_STUDENT = "Student is from restricted country";

export const validator: TAppValidator = async ({
  values,
  backendValidator,
}) => {
  const errors: { [key: string]: any } = {};

  const stepName: string = applyAsStep1.stepName!;
  const stepValues = values[stepName] as IApplicationFrontEndModelStep1;
  const educationType = values.injectedData.educationType;
  const isCheckIntake =
    educationType === EducationType.Secondary ||
    educationType === EducationType.Higher;

  if (!stepValues.student && !stepValues.intake && !stepValues.branch) {
    errors.student = STUDENT_ERROR_MESSAGE;
    errors.intake = INTAKE_ERROR_MESSAGE;
    errors.branch = BRANCH_ERROR_MESSAGE;

    throw {
      [stepName]: errors,
    };
  }

  if (
    !values.injectedData.isStudent &&
    values.injectedData.program.restrictedCountries.includes(
      stepValues.student?.studentProfile.country,
    )
  ) {
    errors.student = RESTRICTED_COUNTRY_STUDENT;
  }

  if (!values.injectedData.isStudent && !stepValues.student) {
    errors.student = STUDENT_ERROR_MESSAGE;
  }

  if (isCheckIntake && !stepValues.intake) {
    errors.intake = INTAKE_ERROR_MESSAGE;
  }

  if (!stepValues.branch) {
    errors.branch = BRANCH_ERROR_MESSAGE;
  }

  if (Object.keys(errors).length > 0) {
    throw {
      [stepName]: errors,
    };
  }

  try {
    if (
      educationType === EducationType.Secondary ||
      educationType === EducationType.Higher
    ) {
      await backendValidator!({
        programId: values.injectedData.programId,
        educationType: values.injectedData.educationType,
        branchId: values[stepName].branch.branchId,
        intakeId: values[stepName].intake.id,
        studentId: values[stepName].student.id,
      });
    } else if (educationType === EducationType.Language) {
      await backendValidator!({
        courseId: values.injectedData.programId,
        educationType: values.injectedData.educationType,
        branchId: values[stepName].branch.branchId,
        studentId: values[stepName].student.id,
      });
    }
  } catch (error) {
    const { message } = mutateErrors(error);

    throw {
      [WIZARD_ERROR_MESSAGE]: message,
    };
  }
};
